import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import AppFormInput from '../../../../components/form/app-form-input';
import Button from '../../../../components/button';
import { apiService } from '../../../../services/api.service';
import { useNavigate } from 'react-router-dom';
import './edit-merchant.part.form.scss';
import InfoDisabled from '../../../../components/info-disabled';
import { errorService } from '../../../../services/error.service';
import { useSelector } from 'react-redux';
import { UserState } from '../../../../store/user.slice';
import { AppStore } from '../../../../store/store';



export interface EditMerchantForm {
    name: string;
}

interface EditMerchantPartFormProps {
    id: string
}



const EditMerchantPartForm: React.FC<EditMerchantPartFormProps> = ({ id }) => {
    const navigate = useNavigate();
    const [initialMerchant, setInitialMerchant] = useState<any>();
    const { user } = useSelector<AppStore, UserState>((state) => state.user);
    const form = useForm<EditMerchantForm>({
        defaultValues: {
          
        },
    });

    useEffect(() => {
        apiService
            .getMerchantById(id)
            .then((response) => {
                const mappedData: EditMerchantForm = {
                    name: response.data.merchant.lastName,
                };
                setInitialMerchant(response.data)
                form.reset(mappedData);
            })
            .catch((e) => console.error(e));
    }, [id, user]);

  

    const onUpdateMerchant = async (data: EditMerchantForm) => {
        if (!initialMerchant) return;
        
        const transformedData = {
                id: initialMerchant.merchant.id,
                firstName: data.name,
                lastName: data.name,
                email: initialMerchant.merchant.email,
                userName: initialMerchant.merchant.userName,
        };

        try {
            await apiService.updateMerchant(transformedData);
            errorService.showSuccess('Success', `Merchant ${data.name} has been updated!`)
            navigate(-1);
        } catch (e) {
            errorService.showApiError(e)
        }
    }


    return (
        <div className="add-merchant-form flex-column flex-gap-30">
            <div className="flex-column flex-gap-15">
                <span className="label">General information</span>
                <div className="flex-row flex-gap-20 ">
                    <AppFormInput
                        control={form.control}
                        name="name"
                        placeholder="Name"
                        validations={{ required: true }}
                    />
                    <InfoDisabled label='Email' value={initialMerchant?.merchant?.email || ''} />
                </div>
            </div>


            <div className='flex-row flex-align-end-end flex-gap-40'>
                <Button
                    label='Cancel'
                    theme='secondary'
                    onClick={() => navigate(-1)}
                />
                <Button
                    label='Save'
                    disabled={!form.formState.isValid}
                    onClick={form.handleSubmit(onUpdateMerchant)}
                />
            </div>
        </div>
    );
};

export default EditMerchantPartForm